var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMmaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 33,
    viewBox: "0 0 29 33",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_392_4799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9402 31.71H9.10021C8.60021 31.71 8.20021 31.31 8.20021 30.81V26.03C2.87021 22.15 0.23021 13.27 1.20021 10.38C1.46021 9.61 1.99021 9.02 2.72021 8.67C3.92021 8.11 5.42021 8.31 6.47021 8.57C6.89021 2.28 10.7002 1 17.0202 1C24.2802 1 28.4802 2.87 28.4802 12.41C28.4802 19.23 26.8202 23.99 25.8402 25.79V30.81C25.8402 31.31 25.4402 31.71 24.9402 31.71ZM10.0002 29.9H24.0402V26.45H10.0002V29.9ZM9.38021 24.64H24.4102C25.3102 22.85 26.6802 18.56 26.6802 12.41C26.6802 4.24 23.5702 2.8 17.0202 2.8C10.4702 2.8 8.24021 4.37 8.24021 9.78C8.24021 10.08 8.09021 10.36 7.84021 10.53C7.59021 10.7 7.28021 10.73 7.00021 10.62C5.91021 10.19 4.35021 9.9 3.48021 10.3C3.19021 10.44 3.01021 10.63 2.91021 10.94C2.21021 13.02 4.47021 21.19 9.37021 24.64H9.38021Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6599 12.4399H11.7399C9.36986 12.4399 7.45986 11.1799 6.69986 10.4299C6.34986 10.0799 6.33986 9.50988 6.69986 9.14988C7.04986 8.78988 7.61986 8.78988 7.97986 9.14988C8.39986 9.55988 9.88986 10.6399 11.7399 10.6399H19.6599C20.1599 10.6399 20.5599 11.0399 20.5599 11.5399C20.5599 12.0399 20.1599 12.4399 19.6599 12.4399Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7399 17.6999C9.75994 17.6999 6.43994 16.6699 6.43994 9.78989C6.43994 9.28989 6.83994 8.88989 7.33994 8.88989C7.83994 8.88989 8.23994 9.28989 8.23994 9.78989C8.23994 13.8399 9.41994 15.8899 11.7399 15.8899C12.2399 15.8899 12.6399 16.2899 12.6399 16.7899C12.6399 17.2899 12.2399 17.6899 11.7399 17.6899V17.6999Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_392_4799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.48,
    height: 30.71,
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmaIcon);
export default __webpack_public_path__ + "static/media/MmaIcon.1ca7ee12abb221800c5b7757bd70d0bb.svg";
export { ForwardRef as ReactComponent };